import './App.css';
import { Routes, Route, Link } from 'react-router-dom';
import Header from './Header';
import About from './pages/About';
import Programs from './pages/Programs';
import Project from './pages/Project';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Event from './pages/Event';
import MyPage from './pages/MyPage';
import EditProfile from './pages/EditProfile';
import EventDetail from './pages/EventDetail';
import CheckIn from './pages/CheckIn';
import Upcoming from './pages/Upcoming';
import WorkHistory from './pages/WorkHistory';
import ServiceHistory from './pages/ServiceHistory';
import PrivateRoute from './components/PrivateRoute';
import SessionWatcher from './components/SessionWatcher';
import VolunteerApplication from './pages/VolunteerApplication';
import VerifyEmail from './pages/VerifyEmail';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import VerifyEmailBanner from './components/VerifyEmailBanner';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LanguageProvider } from './LanguageContext';

function App() {
    return (
        // Wraps everything, not just the auth pages: the delete-account modal
        // on /edit-profile renders a Google button too. An unset client ID is
        // not fatal here the way REACT_APP_API_URL is in client.js -- only the
        // Google button stops working, so the site is not taken down for it.
        <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}
        >
        <LanguageProvider>
            <div className="App">
                <SessionWatcher />
                <Header />
                <VerifyEmailBanner />
                <nav style={{ padding: '10px', textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                    <Link to="/" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Main</Link>
                    <Link to="/about" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>About</Link>
                    <Link to="/programs" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Programs</Link>
                    <Link to="/project" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Project</Link>
                    <Link to="/event" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Event</Link>
                    <Link to="/mypage" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>My Page</Link>
                    <Link to="/edit-profile" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Edit Profile</Link>
                    <Link to="/login" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Login</Link>
                    <Link to="/signup" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Sign Up</Link>
                    <Link to="/volunteer" style={{ margin: '0 10px', color: '#333', textDecoration: 'none' }}>Volunteer</Link>
                </nav>
                {/* Define the routes */}
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/programs" element={<Programs />} />
                    <Route path="/project" element={<Project />} />
                    <Route path="/event" element={<Event />} />
                    {/* Public and unauthenticated on purpose: Google's OAuth
                        consent screen requires both URLs to be reachable
                        without signing in. */}
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route
                        path="/mypage"
                        element={
                            <PrivateRoute>
                                <MyPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/mypage/upcoming"
                        element={
                            <PrivateRoute>
                                <Upcoming />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/mypage/work-history"
                        element={
                            <PrivateRoute>
                                <WorkHistory key="internship" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/mypage/teaching-history"
                        element={
                            <PrivateRoute>
                                <WorkHistory key="instruction" program="instruction" />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/mypage/service-history"
                        element={
                            <PrivateRoute>
                                <ServiceHistory />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/edit-profile"
                        element={
                            <PrivateRoute>
                                <EditProfile />
                            </PrivateRoute>
                        }
                    />
                    <Route path="/login" element={<Auth />} />
                    <Route path="/signup" element={<Auth />} />
                    <Route path="/forgot-password" element={<Auth />} />
                    <Route path="/reset-password" element={<Auth />} />
                    <Route path="/event/detail/:pk" element={<EventDetail />} />
                    {/* Where the printed check-in QR lands. The event travels
                        in the path because Auth.js returns a volunteer to
                        `from.pathname` after login and would drop a query
                        string on the way back. */}
                    <Route
                        path="/event/check-in/:pk"
                        element={
                            <PrivateRoute loginState={{ checkIn: true }}>
                                <CheckIn />
                            </PrivateRoute>
                        }
                    />
                    <Route path="/volunteer" element={<VolunteerApplication />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                </Routes>
            </div>
        </LanguageProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
